export const TIMER_IS_LOW = 'timer_is_low';
export const TIMER_IS_CRITICALLY_LOW = 'timer_is_critical';
export const TIMER_LIMIT_REACHED = 'timer_time_is_over';
export const TIMER_REACHED_NULL = 'timer_reached_null';
export const TIMER_5_MIN_LEFT = 'timer_5_min_left';
